"use strict";
/**
 * Global Invoice API - Response Types
 *
 * Response types for the global invoice (Factura Global) endpoints.
 *
 * @see /api/billing/global-invoices/*
 */
Object.defineProperty(exports, "__esModule", { value: true });
